import React from 'react'
import { Loading, Popup } from 'src/components'
import { useGetPastureHistoricById } from 'src/hooks/api/pasture/useGetPastureHistoricById'
import { useStyles } from './styles'
import { formatDate } from 'src/utils'
import { pastureStatusLabels } from 'src/dto/pasture.dto'

interface PastureModalProps {
  pastureId?: string
  isOpen: boolean
  onClose: () => void
}

export const PastureHistoricModal: React.FC<PastureModalProps> = ({ pastureId, isOpen, onClose }) => {
  const { data: historic, isLoading, isError, refetch, isRefetching } = useGetPastureHistoricById(pastureId!)

  const isLoadingData = isLoading || isRefetching
  const styles = useStyles()

  return (
    <Popup title='Histórico do local' isOpen={isOpen} onClose={onClose} maxWidth='sm'>
      {isLoadingData || isError ? (
        <div className={styles.loadingContainer}>
          <Loading isError={isError} refetch={refetch} />
        </div>
      ) : (
        <div className={styles.modalContent}>
          {historic && historic.length > 0 ? (
            historic.map((item, index) => (
              <div key={index} className={styles.card}>
                <div className={styles.cardHeader}>
                  <span>{formatDate(item.data) || ''}</span>
                </div>

                <div className={styles.cardContent}>
                  <div className={styles.info}>
                    <span>Local:</span>
                    <span>{pastureStatusLabels[item.pasto!] || ''}</span>
                  </div>

                  <div className={styles.info}>
                    <span>Cerca:</span>
                    <span>{pastureStatusLabels[item.cerca!] || ''}</span>
                  </div>

                  <div className={styles.info}>
                    <span>Aguadas:</span>
                    <span>{pastureStatusLabels[item.aguadas!] || ''}</span>
                  </div>

                  <div className={styles.info}>
                    <span>Saleiros:</span>
                    <span>{pastureStatusLabels[item.saleiros!] || ''}</span>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className={styles.noData}>
              <span>Nenhum histórico disponível</span>
            </div>
          )}
        </div>
      )}
    </Popup>
  )
}
